import React from 'react'
import IconButton from './IconButton'
import ActionPrint from 'material-ui-legacy/svg-icons/action/print'

const PrintButton = ({ icon, label, ...restProps }) => (
  <IconButton
    label={label || 'Print'}
    icon={icon || <ActionPrint />}
    {...restProps}
  />
)

export default PrintButton



// WEBPACK FOOTER //
// ./src/components/UI/PrintButton.jsx